webpackJsonp([35783957827783],{

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _qs = __webpack_require__(200);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _components = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FAQPanel = function FAQPanel(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    _components.TabbedArea,
	    null,
	    _react2.default.createElement(
	      _components.TabbedArea.Pane,
	      { title: 'Start Your Application' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Complete our user-friendly online EIN Application Assistant in just 3 simple steps, to safely and securely get a Federal Tax ID (EIN) Number for your business and/or personal needs. Following approval, you will receive your Tax ID (EIN) Number via email in a printable format which you can immediately use. In the event there are any errors on your EIN Application our agents will work with the IRS on your behalf to correct any inaccuracies. This site offers a paid service in which our agents will prepare and submit your EIN Application to the IRS on your behalf for a paid fee based on your delivery needs. Alternatively, for no charge at all you can visit the official IRS.gov website and complete the EIN Application on your own without our assistance. This site is not affiliated with any government agency or official service. Our agents are standing by waiting to assist you.',
	        _react2.default.createElement(
	          'strong',
	          null,
	          _react2.default.createElement(
	            'span',
	            { style: { textTransform: 'uppercase' } },
	            ' ',
	            ' To get started now, choose your entity type below.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _components.TabbedArea.Pane,
	      { title: 'What is an EIN Number?' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Your EIN or Employer Identification Number is used by the IRS to identify you as a tax paying business entity, and many people think of an EIN as their business social security number. Like a social security number, an EIN is a unique nine-digit number assigned by the Internal Revenue Service to business entities (and in some cases individuals) operating in the United States for the purposes of identification.'
	      )
	    ),
	    _react2.default.createElement(
	      _components.TabbedArea.Pane,
	      { title: 'Do I Need an EIN?' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'In most cases, you need an EIN Number under any of the following circumstances:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Your business is new'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You need to pay business taxes'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You have one or more employees'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You want to start a line of business credit'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You plan to open a business bank account'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You form an LLC, Corporation, or Partnership'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _components.TabbedArea.Pane,
	      { title: 'How do I Apply?' },
	      _react2.default.createElement(
	        'p',
	        null,
	        title,
	        ' \xAE provides a safe and secure method for obtaining a new EIN number online, without the need to fill out complex and confusing government forms. Upon approval by the IRS, your Federal Tax ID (EIN) Number will be sent via email, for you to print and start using immediately for many of your business needs. You will also receive a copy of your EIN in the mail. We can have your EIN number approved in 60 minutes or less. This site offers a paid service in which our agents will prepare and submit your EIN Application to the IRS on your behalf for as low as $247 up to $297 depending on your delivery needs. Alternatively, for no charge at all you can visit the official IRS.gov website and complete the EIN Application on your own without our assistance.'
	      )
	    ),
	    _react2.default.createElement(
	      _components.TabbedArea.Pane,
	      { title: 'Why Choose Us?' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Save time preparing complicated government forms and prevent errors by using our easy-to-use online EIN Application Assistant. You can obtain an SS-4 form and try and complete it yourself, or use the IRS website to obtain your number, however if there is any problem with your information you could be forced to call the IRS and spend hours waiting on-hold. For a small fee we will prepare your SS-4 form and work with the IRS to obtain your (EIN) number and deliver it to you quickly and securely via email. If you need to make changes to your information on record with the IRS our agents will provide you with support in updating or correcting your information for no additional fee. Our service makes the employment identification number (EIN) application process quick, easy, and accurate for both individuals and businesses. This site is not affiliated with any government agency.'
	      )
	    )
	  );
	};
	
	var IndexPage = function IndexPage(_ref2) {
	  var data = _ref2.data,
	      _ref2$location$hash = _ref2.location.hash,
	      hash = _ref2$location$hash === undefined ? '' : _ref2$location$hash;
	
	  try {
	    if (hash) {
	      var queryString = hash.split('?').slice(-1)[0];
	      var queryParams = _qs2.default.parse(queryString);
	      if (Object.keys(queryParams).length > 0) {
	        localStorage.setItem('queryParams', JSON.stringify(queryParams));
	      }
	    }
	  } catch (SyntaxError) {
	    console.error('JSON stringify error');
	  }
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'script',
	        { type: 'text/javascript' },
	        '\n            ga(\'require\', \'ec\');\n\n            ga(\'ec:addImpression\', {\n              \'id\': \'sole-proprietor-application\',\n              \'name\': \'Sole Proprietor Application\',\n              \'position\': 1\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'limited-liability-company-application\',\n              \'name\': \'Limited Liability Company Application\',\n              \'position\': 2\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'trust-application\',\n              \'name\': \'Trust Application\',\n              \'position\': 3\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'estate-application\',\n              \'name\': \'Estate Application\',\n              \'position\': 4\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'non-profit-application\',\n              \'name\': \'Non-Profit Application\',\n              \'position\': 5\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'partnership-application\',\n              \'name\': \'Partnership Application\',\n              \'position\': 6\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'corporation-application\',\n              \'name\': \'Corporation\',\n              \'position\': 7\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'scorporation-application\',\n              \'name\': \'Corporation\',\n              \'position\': 8\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'personal-service-application\',\n              \'name\': \'Personal Service Corporation\',\n              \'position\': 9\n            });\n            ga(\'ec:addImpression\', {\n              \'id\': \'church-organization-application\',\n              \'name\': \'Church Organization Application\',\n              \'position\': 10\n            });\n          '
	      )
	    ),
	    _react2.default.createElement(
	      _components.PageWrapper,
	      { step: 1 },
	      _react2.default.createElement(
	        'h4',
	        { className: 'siteSubHeader' },
	        'Start Your Federal Tax ID Application - Get Your Employee Identification Number (EIN) Today'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-12 visible-md visible-lg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formDetails' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'formDetails__subHeader' },
	              'Start Your EIN Application Here'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formDetails__content' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'The Easiest Way To Launch Your Business Today'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'square' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Simple 3 Step Process For Your EIN'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'We Review Your Entire Application, Saving Your Time and Money'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Our Form Takes Just Minutes to Complete'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Fast Review and Turnaround'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  '100% Error Free. Guaranteed.'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 visible-md visible-lg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formDetails' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'formDetails__subHeader_round' },
	              'Step 1: Select Your Entity Type Below'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_components.FormSelection, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 visible-md visible-lg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formDetails' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'formDetails__subHeader' },
	              'Our Simple EIN Application Takes Just Minutes.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formDetails__content' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Every business needs a Tax ID (EIN) to operate.',
	                ' ',
	                'We make that process simple for you, because we know you have other things to do.'
	              ),
	              _react2.default.createElement(
	                'h5',
	                null,
	                'What is an Employee Identification Number (EIN)? An EIN allows your business to:'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'square' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Open a Bank Account'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Start Payroll'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'File Federal and State Reports'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'File Tax Returns'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Obtain Lines of Credit'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-eac6126bf65ca469dd65.js